import { locationPages } from "./locations";
import { guidePages } from "./guides";
import { spaPages } from "./spa";
import { servicePages } from "./services";

export const landingPages = [...locationPages, ...guidePages, ...spaPages, ...servicePages];
